export const withSelectedFolder = (
	folders: string[],
	selected: string | null,
): string[] =>
	selected && !folders.includes(selected) ? [...folders, selected] : folders;
